<template>
  <b-container
    fluid
  >
    <div class="d-flex justify-content-end mb-2 pb-0">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-container fluid>

      <b-row>

        <b-col
          cols="12"
          md="10"
          class="px-1"
          order="2"
          order-md="1"
        >
          <b-form-group
            label="Search"
            label-for="filter_item_center_search"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_item_center_search"
              v-model="tableItem.filter.search"
              type="text"
              placeholder="search here"
              debounce="1000"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="2"
          class="px-1"
          order="1"
          order-md="2"
        >
          <b-form-group
            label="Budget Center"
            label-for="filter_budget_center"
            label-class="font-weight-bolder"
          >
            <b-select
              id="filter_budget_center"
              v-model="tableItem.filter.budget_center"
              value-field="id"
              text-field="budget_name"
              debounce="1000"
              :options="filterBudgetCenters"
              :disabled="state.busy || fetching.budgetCenters"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          order="3"
          class="px-1 mb-2"
        >
          <b-button
            size="sm"
            type="button"
            variant="success"
            @click="onCreateItem"
          >
            Add Item
          </b-button>
        </b-col>

      </b-row>

      <b-row class="mt-1">
        <b-col
          cols="12"
          class="px-1"
        >
          <b-table
            ref="tableItem"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :per-page="tableItem.perPage"
            :current-page="tableItem.currentPage"
            :items="tableItemProvider"
            :fields="tableItem.fields"
            :sort-by.sync="tableItem.sortBy"
            :sort-desc.sync="tableItem.sortDesc"
            :sort-direction="tableItem.sortDirection"
            :filter="tableItem.filter"
            :filter-included-fields="tableItem.filterOn"
            :busy="tableItem.busy"
          >
            <template #cell(index)="row">
              {{ tableItem.currentPage * tableItem.perPage - tableItem.perPage + (row.index + 1) }}
            </template>

            <template #cell(active)="row">
              {{ Number(row.value) === 1 ? 'Yes' : 'No' }}
            </template>

            <template #cell()="row">
              <div class="text-md-nowrap">
                {{ row.value }}
              </div>
            </template>

            <template #cell(action)="row">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <b-button
                  size="sm"
                  variant="success"
                  @click="onEditItem(row.item)"
                >
                  Edit
                </b-button>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <b-icon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </b-table>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <b-select
            v-model="tableItem.perPage"
            :options="tableItem.pageOptions"
            class="w-100 w-md-25"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <b-pagination
            v-model="tableItem.currentPage"
            pills
            last-number
            first-number
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
            :total-rows="tableItem.totalRows"
            :per-page="tableItem.perPage"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="modal-item"
      size="md"
      scrollable
      no-close-on-esc
      no-enforce-focus
      hide-header-close
      no-close-on-backdrop
      :title="ModalItemTitle"
    >
      <ValidationObserver
        ref="formItem"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <b-row>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="budget center"
                vid="budget_center"
              >
                <b-form-group
                  label="Budget Center"
                  label-for="budget_center"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <v-select
                    v-model="selected.budgetCenter"
                    input-id="budget_center"
                    type="text"
                    label="budget_name"
                    placeholder="search budget center here"
                    :options="lists.budgetCenters"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="state.busy || fetching.budgetCenters"
                    :loading="fetching.budgetCenters"
                  >
                    <template #no-options="">
                      no available budget center
                    </template>
                  </v-select>
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="item name"
                vid="item_name"
                rules="required|max:255"
              >
                <b-form-group
                  label="Item Name"
                  label-for="item_name"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-textarea
                    id="item_name"
                    v-model="item.item_name"
                    rows="5"
                    max-rows="6"
                    maxlength="255"
                    autocomplete="off"
                    placeholder="enter item name here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                    @keydown="onKeydownItemName"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col
              v-if="state.editing"
              cols="12"
            >
              <b-form-group>
                <b-form-checkbox
                  id="is_active"
                  v-model="item.active"
                  name="is_active"
                  value="1"
                  unchecked-value="0"
                  :disabled="state.busy"
                  switch
                >
                  Is Active?
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </ValidationObserver>

      <template #modal-footer="{ cancel }">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="onValidateItem"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="outline-dark"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>

<script>
import QUERY from 'lodash'
import { core } from '@/config/pluginInit'
import { SBOItem, SSharedList } from '@/services'
import formatter from '@/mixins/formatter'
import misc from '@/mixins/misc'

export default {
  name: 'BoMaintenancesItems',

  middleware: ['auth', 'bo'],

  mixins: [misc, formatter],

  metaInfo: () => ({
    title: 'Items'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      fetching: {
        budgetCenters: false
      },
      lists: {
        budgetCenters: []
      },
      selected: {
        budgetCenter: null
      },
      item: {
        id: null,
        budget_center: null,
        item_name: null,
        active: 1
      },
      tableItem: {
        perPage: 10,
        pageOptions: [5, 10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: null,
          budget_center: 'All'
        },
        filterOn: [],
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 6, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'created_at', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'budget_center.budget_name', label: 'Budget Center' },
          { mobile: 3, key: 'item_name' },
          { mobile: 4, key: 'active', class: 'text-center' },
          { mobile: 5, key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ModalItemTitle () {
      return this.state.editing ? 'Edit Item' : 'Add Item'
    },

    filterBudgetCenters () {
      return [{ id: 'All', budget_name: 'All' }].concat(this.lists.budgetCenters)
    }
  },

  watch: {

    'item.item_name' (itemName) {
      if (itemName?.search(/\n/g)) {
        this.item.item_name = itemName.replace(/\n/g, '')
      }
    },

    'selected.budgetCenter' (budgetCenter) {
      this.item.budget_center = budgetCenter?.id || null
    }

  },

  mounted () {
    core.index()
    this.getBudgetCenters()
  },

  methods: {

    onKeydownItemName (event) {
      if (event.keyCode === 13) {
        event.preventDefault()
      }
    },

    async tableItemProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableItem.busy = true
      return await SBOItem.get(
        this.objectToUrl({
          page: currentPage,
          per_page: perPage,
          sort: sortBy,
          sort_desc: sortDesc,
          filter_text: filter.search,
          budget_center: filter.budget_center
        })
      ).then(({ data }) => {
        this.tableItem.totalRows = data.total_rows
        return data.items
      }).catch(() => []).finally(() => {
        this.tableItem.busy = false
      })
    },

    tableItemRefresh () {
      this.$refs.tableItem.refresh()
    },

    async getBudgetCenters () {
      this.state.busy = this.fetching.budgetCenters = true
      return new Promise(resolve => {
        SSharedList.getBudgetCenters().then(
          ({ data }) => {
            this.lists.budgetCenters = data
            resolve(data)
          }
        )
      }).finally(() => {
        this.state.busy = this.fetching.budgetCenters = false
      })
    },

    onCreateItem () {
      this.state.editing = false

      this.item.id = null
      this.item.item_name = null
      this.item.active = 1

      this.selected.budgetCenter = null

      this.$bvModal.show('modal-item')
    },

    onEditItem (item) {
      this.state.editing = true
      this.item.id = item.id
      this.item.item_name = item.item_name
      this.item.active = item.active

      this.selected.budgetCenter = QUERY.find(this.lists.budgetCenters, { id: item.budget_center_id })

      this.$bvModal.show('modal-item')
    },

    async onValidateItem (event) {
      event.preventDefault()
      await this.$refs.formItem.validate().then(
        async allFieldsAreValid => {
          if (allFieldsAreValid) {
            this.swalConfirm({
              confirmButtonText: event.target.innerText,
              html: () => {
                if (this.state.editing) {
                  return '<h6>Save your Changes on this Item?</h6>'
                }
                return '<h6>Create this Item?</h6>'
              },
              preConfirm: () => {
                this.state.busy = true
                if (this.state.editing) {
                  return this.onPutItem()
                }
                return this.onPostItem()
              }
            })
          } else {
            this.swalInvalid()
          }
        }
      )
    },

    async onPostItem () {
      return new Promise(resolve => {
        SBOItem.post(this.item).then(
          ({ data: { message } }) => {
            this.tableItemRefresh()
            this.swalSuccess(message).then(() => {
              this.$bvModal.hide('modal-item')
            })
            resolve(message)
          }
        ).catch(
          ({ message }) => {
            this.$refs.formItem.setErrors(message)
            resolve(message)
          }
        ).finally(() => {
          this.state.busy = false
        })
      })
    },

    async onPutItem () {
      return new Promise(resolve => {
        SBOItem.put(this.item).then(
          ({ data: { message, item } }) => {
            const tableItemRow = QUERY.find(this.$refs.tableItem.localItems, { id: item.id })
            if (tableItemRow) {
              tableItemRow.budget_center = item.budget_center
              tableItemRow.item_name = item.item_name
              tableItemRow.active = item.active
              tableItemRow.updated_at = item.updated_at
            }
            this.swalSuccess(message).then(() => {
              this.$bvModal.hide('modal-item')
            })
            resolve(message)
          }
        ).catch(
          ({ message }) => {
            this.$refs.formItem.setErrors(message)
            resolve(message)
          }
        ).finally(() => {
          this.state.busy = false
        })
      })
    }
  }
}
</script>
